import {USER_REGISTERATION} from "../../types";
import {USER_LOGGED_IN} from "../../types";
import api from "../../api";

//not necessary
export const userRegisterationA = (data) => ({
    type: USER_REGISTERATION,
    data
})

export const userRegisteration = (data) => dispatch =>  
    api.user.register(data);

export const logout = (credentials) => dispatch => {
    localStorage.removeItem("BookAppLogin");
    api.user.logout().then(msg => {
        window.location.reload();
    }).catch(msg => {
        localStorage.loggouted = true;
        window.location.reload();
    });
    dispatch(userloggedIn({}));
}


export const login = (credentials) => dispatch => 
    api.user.login(credentials).then ((data) => {
        localStorage.BookAppLogin = true;
        dispatch(userloggedIn(data))
    })

export const userloggedIn = (user) => ({
    type: USER_LOGGED_IN,
    user
})

//set user data in index.js instead. 
export const setUserData = (token) => dispatch =>
    api.user.getUserData(token).then(user => {
        dispatch(userloggedIn(user))
})

export const uploadImage = (data) => dispatch =>
    api.user.uploadImage(data).then(user => {
        dispatch(userloggedIn(user))
})

export const changeName = (data) => dispatch =>
    api.user.changeName(data).then(user => {
        dispatch(userloggedIn(user))
})


export const editProfile = (data) => dispatch => 
    api.user.editProfile(data).then ((user) => {
        dispatch(userloggedIn(user))
    })